import React from "react";
import styled from "@emotion/styled";
import breakpoints from "../../helpers/breakpoints";

const Root = styled.div`
  padding: 100px 0;
  @media (min-width: ${breakpoints.min.lg}) {
    padding: 112px 0 60px;
  }
`;

const Subpage: React.FC = ({ children }) => {
  return <Root>{children}</Root>;
};

export default Subpage;
